import catPhoto from '../images/photo-cat.png';

export const catFood = [
  {
    id: 0,
    type: 'Сказочное заморское яство',
    name: 'Нямушка',
    taste: 'с фуа-гра',
    packageQuantity: '10',
    giftMouse: '1',
    addition: '',
    weight: '0,5',
    description: 'Печень утки разварная с артишоками',
    stockQuantity: 10,
    img: catPhoto,
  },
  {
    id: 1,
    type: 'Сказочное заморское яство',
    name: 'Нямушка',
    taste: 'с рыбой',
    packageQuantity: '40',
    giftMouse: '2',
    addition: '',
    weight: '2',
    description: 'Головы щучьи с чесноком да свежайшая сёмгушка',
    stockQuantity: 10,
    img: catPhoto,
  },
  {
    id: 2,
    type: 'Сказочное заморское яство',
    name: 'Нямушка',
    taste: 'с курой',
    packageQuantity: '100',
    giftMouse: '5',
    addition: 'заказчик доволен',
    weight: '5',
    description: 'Филе из цыплят с трюфелями в бульоне',
    stockQuantity: 0,
    img: catPhoto,
  },
];
